<div class="block-items-2">
    <ng-content></ng-content>
</div>
